import type { Signal } from '@angular/core';
import { computed } from '@angular/core';

import { translateNow, translationVersion } from '../../core/services/i18n/translate-now';

/**
 * Text from the `common` catalog that follows language changes, for shared components that must
 * render without Transloco providers.
 *
 * @param key Catalog key such as `common.dialog.close`.
 * @param params Optional source of `{name}` values, read every time the text is rebuilt.
 * @returns A signal with the text in the active language.
 * @example
 * protected readonly closeLabel = translated('common.dialog.close');
 */
export function translated(key: string, params?: () => Record<string, unknown>): Signal<string> {
  return computed(() => {
    translationVersion(); // rebuilt when the language changes
    return translateNow(key, params?.());
  });
}
